module.exports = __webpack_public_path__ + "static/media/26UNRWA16.b885ecb9.jpg";